import "./style/global.less";
import { Provider } from "react-redux";
import store from "./store/index";
import DataProcessing from "./View/DataProcessing/index";
import { useEffect, useState } from "react";
import { Amplify } from "aws-amplify";
import {
  getEncryptDataFromPath,
  getAWSS3ServiceClient,
  handleRefreshToken,
  loginByRefreshToken,
  AUTH_CLIENT_METADATA,
} from "./utils";
import { message } from "antd";
import { config, readonly_config } from "./config/amplify";
import { getMode } from "./utils";
import { addPerform } from "./tools/perform-tool";

Amplify.configure(config);

function App() {
  const [buildTarget, setBuildTarget] = useState("");
  const { readOnlyMode } = getMode();

  const fetchBuildConfig = () => {
    fetch("./buildConfig.json")
      .then((response) => response.json())
      .then((data) => {
        if (data !== null) {
          setBuildTarget(data.buildTarget);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const reLogin = async () => {
    try {
      Amplify.configure(config);
      const { username, password, refreshToken } = getEncryptDataFromPath();

      if (refreshToken) {
        addPerform({ name: "login.onLoadWithRefreshToken.start" });
        await onLoadWithRefreshToken();
        addPerform({ name: "login.onLoadWithRefreshToken.end" });
      }

      if (username && password) {
        addPerform({ name: "login.onLoadWithUsernameAndPassword.start" });
        await Amplify.Auth.signIn(username, password, AUTH_CLIENT_METADATA);
        addPerform({ name: "login.onLoadWithUsernameAndPassword.end" });
      }
      console.log("Re-login successful");
      fetchBuildConfig();
    } catch (err) {
      console.error("Failed to re-login:", err);
      message.warn(`Failed to Re-login`);
    }
  };

  /**
   * use username & password
   */
  const onLoad = async () => {
    try {
      await Amplify.Auth.currentAuthenticatedUser();
      fetchBuildConfig();
    } catch {
      reLogin();
    }
  };

  /**
   *
   */
  const anonymousAccountLogin = async () => {
    try {
      addPerform({ name: "login.anonymousAccountLogin.start" });
      Amplify.configure(readonly_config);
      addPerform({ name: "login.anonymousAccountLogin.end" });
      const username = "61ab55f0-d0d1-7080-d73f-050b5a37fa14";
      const password = "WebViewer2Guest20240413!";
      await Amplify.Auth.signIn(username, password, AUTH_CLIENT_METADATA);
      console.log("Anonymous Account Login Success");
      fetchBuildConfig();
    } catch (err) {
      console.log("Anonymous Account Login Failed:", err);
      // message.warn(`Failed to Re-login`)
      // In order to be compatible with old dashboard version
      reLogin();
    }
  };

  /**
   * use jwtToken credential
   */
  const onLoadWithJwtToken = async () => {
    if (readOnlyMode) {
      // TODO: use anonymous account credential
    }
    const { token } = getEncryptDataFromPath();
    await getAWSS3ServiceClient(token);
    fetchBuildConfig();
  };

  /**
   * use refreshToken to request new accessToken credential
   */
  const onLoadWithRefreshToken = async () => {
    // TODO: ERR: NotAuthorizedException: Invalid login token. Missing a required claim: aud
    const { refreshToken } = getEncryptDataFromPath();
    await loginByRefreshToken(refreshToken);
    fetchBuildConfig();
  };

  useEffect(() => {
    if (readOnlyMode) {
      anonymousAccountLogin();
    } else {
      onLoad();
    }
  }, []);

  return (
    <Provider store={store}>
      <div
        className="App"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {buildTarget === "" ? (
          <></>
        ) : (
          <DataProcessing buildTarget={buildTarget} />
        )}
      </div>
    </Provider>
  );
}

export default App;
